// extracted by mini-css-extract-plugin
export default {"switcher__hint":"switcher__hint--MyVFW64i","switcher__wrapper":"switcher__wrapper--h6XxwXH7"};